export const CLIENT_RELEASE_TARGETS = [
  { id: 'android', label: 'Android', group: 'mobile', icon: 'ri-android-line', extension: '.apk' },
  { id: 'ios', label: 'iOS', group: 'mobile', icon: 'ri-apple-line', extension: '.ipa' },
  {
    id: 'windows-x64',
    label: 'Windows x64',
    group: 'desktop',
    icon: 'ri-windows-line',
    extension: '.exe',
  },
  {
    id: 'macos-arm64',
    label: 'macOS · Apple 芯片',
    group: 'desktop',
    icon: 'ri-macbook-line',
    extension: '.dmg',
  },
  {
    id: 'macos-x64',
    label: 'macOS · Intel',
    group: 'desktop',
    icon: 'ri-macbook-line',
    extension: '.dmg',
  },
] as const;

export type ClientReleaseTarget = (typeof CLIENT_RELEASE_TARGETS)[number]['id'];
export type ClientReleaseChannel = 'stable' | 'test';
export type ClientReleaseStatus = 'draft' | 'published' | 'archived';
export const CLIENT_RELEASE_CHUNK_BYTES = 6 * 1024 * 1024;
export const CLIENT_RELEASE_MAX_BYTES = 1024 ** 3;

export interface ClientReleaseInput {
  target: ClientReleaseTarget;
  version: string;
  channel: ClientReleaseChannel;
  notes: string;
  delivery: 'file' | 'external';
  externalUrl: string;
}

export interface ClientReleaseFile {
  name: string;
  size: number;
  sha256: string;
}

export interface ClientReleaseView extends ClientReleaseInput {
  id: string;
  revision: number;
  status: ClientReleaseStatus;
  isCurrent: boolean;
  file: ClientReleaseFile | null;
  publishedAt: string | null;
  updatedAt: string;
  downloadUrl: string;
}

export interface ClientReleaseUploadView {
  id: string;
  offset: number;
  chunkBytes: number;
}

export interface ClientReleaseAdminView extends ClientReleaseView {
  upload: (ClientReleaseUploadView & { name: string; size: number; status: string }) | null;
}
